// src/pages/Services.js
import React from 'react';

const services = [
  {
    title: "Application Development",
    sub: [
      "Software Development",
      "iOS Development",
      "Android App Development",
      "Web Development",
    ],
  },
  {
    title: "Web Scraping and Automation",
    sub: [
      "E-Commerce",
      "Dropshipping",
      "Insurance",
      "Research",
      "PDF Data Extracting",
      "Image Extracting",
    ],
  },
  {
    title: "IoT",
    sub: [
      "Arduino",
      "Micro Controller",
    ],
  },
  {
    title: "Cloud Services",
    sub: [
      "AWS",
      "Google Cloud",
      "Azure",
      "Digital Ocean",
    ],
  },
  {
    title: "Data Science",
    sub: [
      "AI",
      "ML",
      "Big Data Analytics",
    ],
  },
  {
    title: "Digital Marketing",
    sub: [
      "Social Media Marketing",
      "Virtual Assistant",
    ],
  },
];

const Services = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-12">Our Services</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {services.map((section, index) => (
          <div
            key={index}
            className="bg-accent shadow-md rounded-xl p-6 border border-secondary/10 hover:shadow-lg transition"
          >
            <h2 className="text-xl font-semibold text-primary mb-4">
              {section.title}
            </h2>
            <ul className="list-inside space-y-2 text-secondary">
              {section.sub.map((item, subIndex) => (
                <li key={subIndex} className="flex items-start">
                  <span className="text-primary mr-2">✅</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
